import { Injectable } from '@angular/core';

import { AuthenticationService } from '../authentication/authentication.service';

@Injectable()
export class AuthGuard {
    constructor(private authenticationService: AuthenticationService) {}

    canActivate(): boolean {
        const isAuthenticated = this.authenticationService.isAuthenticated();

        if (!isAuthenticated) {
            this.authenticationService.logout(true).catch(() => {});
        }

        return isAuthenticated;
    }
}
